import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ActionButton } from '@/components';
import { INGREDIENTS_ROUTE } from '@/routes';

export const IngredientsActionsHeader = ({
  mode,
  onSubmit,
}: {
  mode: 'create' | 'edit';
  onSubmit: () => void;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        width: '100%',
        height: '90px',
        padding: '24px 46px',
      }}
    >
      <Stack
        direction="row"
        onClick={() => {
          navigate(INGREDIENTS_ROUTE);
        }}
        sx={{
          gap: '8px',
          cursor: 'pointer',
        }}
      >
        <KeyboardArrowDownIcon sx={{ transform: 'rotate(90deg)' }} />
        <Typography variant="h2">
          {mode === 'create' ? t('INGREDIENT.ADD') : t('INGREDIENT.EDIT')}
        </Typography>
      </Stack>
      <Stack
        sx={{
          width: '100%',
          maxWidth: '71px',
        }}
      >
        <ActionButton label={t('GLOBAL.SAVE')} actionType="ACTION" onClick={onSubmit} />
      </Stack>
    </Stack>
  );
};
